<div *ngIf="logos" [ngStyle]="{'height':getPatrocinadoresHeight()+'px'}"
     style="height:92px;width:100%;padding-top:5px;padding-bottom:5px;background-color:rgb(255,255,255);" class="d-flex justify-content-center">
    <div *ngFor="let logo of logos"
         style="display:flex;align-items:center;justify-content:center;height:100%;"
         [ngStyle]="{'width':getPatrocinadoresWidth(logos.length)+'px'}">
        <img src="{{logo}}" style="max-width:100%; max-height:100%;" alt="">
    </div>
</div>
